module.exports = __webpack_public_path__ + "static/media/icon-cm-download.fdfb7ce1.svg";